import React, { useState } from 'react';
import p from '../../styles/renewal/OnePage.module.css';
import { FAQS, NEWS } from './data';
import { noTranslate } from './formatters';

/** 시안 #faq — 좌측 FAQ 아코디언 + 우측 새로운 소식 3건 */
const FaqNotice = () => {
  const [open, setOpen] = useState(0);

  return (
    <section className={`${p.splitGrid} ${p.reveal}`}>
      <div>
        <div className={p.badge} translate="no">FAQ</div>
        <h2 className={p.titleMd}>
          궁금한 점을
          <br />
          먼저 정리했습니다
        </h2>

        <div className={p.faqList}>
          {FAQS.map((faq, i) => {
            const isOpen = open === i;
            return (
              <div className={p.faqItem} key={faq.q}>
                <button
                  type="button"
                  className={p.faqBtn}
                  translate={noTranslate(faq.q)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                >
                  <span className={p.faqNo}>{i + 1}</span>
                  {faq.q}
                  <span
                    className={`${p.faqMark} ${isOpen ? p.faqMarkOpen : ''}`}
                    aria-hidden="true"
                  >
                    ▾
                  </span>
                </button>
                {isOpen ? (
                  <p className={p.faqAnswer} id={`faq-answer-${i}`} translate={noTranslate(faq.a)}>
                    {faq.a}
                  </p>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>

      <div>
        <div className={p.badge} translate="no">NOTICE</div>
        <h2 className={p.titleMd}>새로운 소식</h2>

        <div className={p.noticeList}>
          {NEWS.slice(0, 3).map((item) => (
            <div className={p.noticeCard} key={item.title}>
              <div className={p.noticeTitle} translate={noTranslate(item.title)}>{item.title}</div>
              <div className={p.noticeDate}>{item.date}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqNotice;
